export default __webpack_public_path__ + "static/icon-amplop-f85979dce4e0850f0c7ef849fcc9ed60.png";